module.exports = __webpack_public_path__ + "media/images/team__fireballsgc-314115ff3f9266ee348c25dd60254539.png";